export default "/flow-constructor";
